import ddt from '@wix/da-ddt';

export enum GallectionType {
  GALLERY = 'gallery',
  COLLECTION = 'collection',
  PRIVATE_COLLECTION = 'private_collection',
  STASH = 'stash',
}

export enum GallectionResourceType {
  GALLERY = 20,
  COLLECTION = 21,
  PRIVATE_COLLECTION = 88,
  STASH = 89,
}

export function gallectionTypeToResourceType(
  // accomodate type being defined as a plain string in PapiGallection
  typeString: GallectionType | string
): GallectionResourceType | undefined {
  switch (typeString) {
    case GallectionType.GALLERY:
      return GallectionResourceType.GALLERY;
    case GallectionType.COLLECTION:
      return GallectionResourceType.COLLECTION;
    case GallectionType.PRIVATE_COLLECTION:
      return GallectionResourceType.PRIVATE_COLLECTION;
    case GallectionType.STASH:
      return GallectionResourceType.STASH;
    default:
      ddt.error(`unknown GallectionType: ${typeString}`);
      return undefined;
  }
}

export enum PremiumFolderType {
  Watchers = 'watchers',
  Paid = 'paid',
  Regular = 'regular',
}
